var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 1.4165H6.375C5.59371 1.4165 4.95833 2.05188 4.95833 2.83317V7.08317H3.54167C2.76037 7.08317 2.125 7.71855 2.125 8.49984V14.8748C2.125 15.0627 2.19963 15.2429 2.33247 15.3757C2.4653 15.5085 2.64547 15.5832 2.83333 15.5832H14.1667C14.3545 15.5832 14.5347 15.5085 14.6675 15.3757C14.8004 15.2429 14.875 15.0627 14.875 14.8748V2.83317C14.875 2.05188 14.2396 1.4165 13.4583 1.4165ZM3.54167 8.49984H7.79167V14.1665H3.54167V8.49984ZM13.4583 14.1665H9.20833V8.49984C9.20833 7.71855 8.57296 7.08317 7.79167 7.08317H6.375V2.83317H13.4583V14.1665Z",
    fill: "#007DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79159 4.25H9.20825V5.66667H7.79159V4.25ZM10.6249 4.25H12.0416V5.66667H10.6249V4.25ZM10.6249 7.10529H12.0416V8.5H10.6249V7.10529ZM10.6249 9.91667H12.0416V11.3333H10.6249V9.91667ZM4.95825 9.91738H6.37492V11.334H4.95825V9.91738Z",
    fill: "#007DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInfo);
export default __webpack_public_path__ + "static/media/general-info.914a4a8d5bf7ca3d866a5b2f66ed51d0.svg";
export { ForwardRef as ReactComponent };